export class Office {
  public OfficeUniqueId: number = 0;
  public constituency: string = '';
  public electedBody: string = '';
  public electoralDistrict: string = '';
  public state: string = '';
}
